import { getAllParamValues, getParamValue } from "@pepsico/pref-permissions";

import { LAYERS_PREF_KEY, ORTHOS_PREF_KEY, type PlotMapLayer } from "defs";

export const ORTHOS_NONE_PREF = "none";

const ORTHOMOSAIC_LAYER: PlotMapLayer = "orth";

export const isPlotMapOrthomosaicLayerVisible = (
  prefs: Record<string, string | string[]>,
): boolean =>
  getAllParamValues(prefs, LAYERS_PREF_KEY).includes(ORTHOMOSAIC_LAYER);

export const isPlotMapOrthoVisible = (
  prefs: Record<string, string | string[]>,
  orthoId: number,
  availableOrthoIds: readonly number[],
): boolean => {
  const stored = getParamValue(prefs, ORTHOS_PREF_KEY);
  if (stored === ORTHOS_NONE_PREF) {
    return false;
  }
  // Only an unset pref falls back to the newest ortho. A stored id that is
  // not displayable stays unmatched until the pref itself changes.
  if (stored == null) {
    return availableOrthoIds[0] === orthoId;
  }

  const id = Number(stored);
  return availableOrthoIds.includes(id) && id === orthoId;
};
